import { useHistory } from "react-router-dom";
import { GETMESSAGEBYEVENT } from ".";
import { NotificationsT } from "../components/Notifications/NotificationBell";

export const ConstructNotificationMessage = (messageData: NotificationsT) => {
  const history = useHistory();

  if (messageData.event_name.startsWith("agent")) {
    const eventAction = Object.entries(GETMESSAGEBYEVENT).find(
      (entry) => entry[0] === messageData.event_name
    );
    if (eventAction) {
      const messageContent = eventAction[1];
      const agentId: string = messageData.details.agent_id;
      const orgId: string = messageData.org_id;
      return (
        <>
          <a
            href={`/organisation/${orgId}/${agentId}`}
            style={{ color: "#0d6efd" }}
          >
            {messageData.details.agent_name}
          </a>{" "}
          Agent has been
          {messageContent[0]} {messageData.details.user_name ? " by" : ""}{" "}
          {messageData.details.user_name}
          {messageContent[1]} for the organization{" "}
          <a href={`/organisation/${orgId}`} style={{ color: "#0d6efd" }}>
            {messageData.org_name}
          </a>
        </>
      );
    }
  }
  if (messageData.event_name.startsWith("task")) {
    const eventAction = Object.entries(GETMESSAGEBYEVENT).find(
      (entry) => entry[0] === messageData.event_name
    );
    if (eventAction) {
      const messageContent = eventAction[1];
      const agentId: string = messageData.details.agent_id;
      const orgId: string = messageData.org_id;
      return (
        <>
          <a
            href={`/organisation/${orgId}/${agentId}/logs`}
            style={{ color: "#0d6efd" }}
            onClick={() =>
              history.push({
                pathname: `/organisation/${orgId}/${agentId}/logs`,
                state: messageData.details.task_id,
              })
            }
          >
            {messageData.details.task_name}
          </a>{" "}
          {messageData.details.run_id
            ? ` (${messageData.details.run_id}) `
            : " "}{" "}
          task {messageContent[1]} in the Agent{" "}
          <a
            href={`/organisation/${orgId}/${agentId}`}
            style={{ color: "#0d6efd" }}
          >
            {messageData.details.agent_name}
          </a>{" "}
          for the organization{" "}
          <a href={`/organisation/${orgId}`} style={{ color: "#0d6efd" }}>
            {messageData.org_name}
          </a>
        </>
      );
    }
  }
  if (messageData.event_name.startsWith("license")) {
    const eventAction = Object.entries(GETMESSAGEBYEVENT).find(
      (entry) => entry[0] === messageData.event_name
    );
    if (eventAction) {
      const messageContent = eventAction[1];
      const orgId: string = messageData.org_id;
      return (
        <>
          {messageContent[0]}{" "}
          {Number(messageData.details.single_task_agent) !== 0
            ? `${
                Number(messageData.details.single_task_agent) < 0
                  ? `${String(messageData.details.single_task_agent).replace(
                      "-",
                      ""
                    )} single task agent licenses have been reduced,`
                  : `${messageData.details.single_task_agent} additional single task agent licenses have been allocated,`
              }`
            : ""}{" "}
          {Number(messageData.details.multiple_task_agent) !== 0
            ? `${
                Number(messageData.details.multiple_task_agent) < 0
                  ? `${String(messageData.details.multiple_task_agent).replace(
                      "-",
                      ""
                    )} multiple task agent licenses have been reduced,`
                  : `${messageData.details.multiple_task_agent} additional multiple task agent licenses have been allocated,`
              }`
            : ""}{" "}
          to the organization{" "}
          <a href={`/organisation/${orgId}`} style={{ color: "#0d6efd" }}>
            {messageData.org_name}
          </a>
        </>
      );
    }
  }
};
